@import '../component/_useragent.js'
document.createElement("picture");
svg4everybody();

$(function() {

	// 予約フォーム　店舗セレクトボックス
	var arg = new Object;
	url = location.search.substring(1).split('&');
	for (i = 0; url[i]; i++) {
		var k = url[i].split('=');
		arg[k[0]] = k[1];
	}
	var id = arg.id;

	var list = {
		'honin': 'ソリデンテ南青山 本院',
		'gakugeidai': 'ソリデンテ学芸大学',
		'urawa': 'ソリデンテ浦和',
		'shinsaibashi': 'ソリデンテ心斎橋'
	}

	var list_id = list[id];

	$("#js-select-shop").val(list_id);


	$('#toggle-voice--btn').on('click', function(event) {
		$('#toggle-voice--btn').fadeOut(200);
		setTimeout(function() {
			$('#toggle-voice').slideDown(400);
		}, 200);
	});
	$('.js-close').on('click', function(event) {
		$('#toggle-voice').slideUp(400);
		setTimeout(function() {
			$('#toggle-voice--btn').fadeIn(400);
		}, 400);
	});


	$('#toggle-bigener--btn').on('click', function(event) {
		$('#salon').slideUp(400);
		// setTimeout(function() {
		$('#toggle-bigener').slideDown(400);
		// }, 200);
	});
	$('.js-close').on('click', function(event) {
		$('#toggle-bigener').slideUp(400);
		setTimeout(function() {
			$('#salon').slideDown(400);
		}, 300);
	});

	function targetCu() {
		var margin = 100,
			sectionTop = new Array,
			current = -1;
		$('.anchor-position').each(function(i) {
			sectionTop[i] = $(this).offset().top;
		});
		changeNavCurrent(0);
		$(window).on('scroll', function() {
			scrollY = $(window).scrollTop();
			for (var i = sectionTop.length - 1; i >= 0; i--) {
				if (scrollY > sectionTop[i] - margin) {
					changeNavCurrent(i);
					break;
				}
			};
		});

		function changeNavCurrent(curNum) {
			if (curNum != current) {
				current = curNum;
				curNum2 = curNum + 0;
				$('.navi__global li').removeClass('is-current');
				$('.navi__global li:nth-child(' + curNum2 + ')').addClass('is-current');
			}
		};
	}

	$(window).on('load ', function() {
		targetCu();
	})

	// if ($('html').hasClass('isIE')) {
	// 	$(window).on('scroll', function() {
	// 		targetCu();
	// 	});
	// }
	// if ($('html').hasClass('firefox')) {
	// 	$(window).on('scroll', function() {
	// 		targetCu();
	// 	});
	// }


	var timer = false;
	//リサイズ時ファンクション再実行
	$(window).on('resize', function() {
		if (timer !== false) {
			clearTimeout(timer);
		}
		timer = setTimeout(function() {
			// console.log('resized');
			targetCu();
		}, 200);
	});

	@import '../component/_carousel.js'

	@import '../component/_waypoint.js'

	@import '../component/_navi.js'
	@import '../component/_validation.js'
	@import '../component/_smoothscroll.js'


	$('.menu-btn-more').on('click', function(event) {
		$(this).next('.menu-list').slideToggle(400);
	});

});

$(window).on('load', function() {
	$('html').addClass('is-loaded');
});
